var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetodologyWeaksignalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.9999,
    cy: 47.9999,
    r: 9.72,
    stroke: "#11A0DA",
    strokeWidth: 0.72
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0589 14.0594C9.60166 18.5167 6.06601 23.8081 3.65379 29.6318C1.24156 35.4554 2.94271e-07 41.6971 1.64297e-06 48.0006C2.99167e-06 54.304 1.24156 60.5457 3.65378 66.3694C6.06601 72.193 9.60166 77.4845 14.0589 81.9417L14.7377 81.2629C10.3696 76.8948 6.90469 71.7091 4.54071 66.002C2.17673 60.2948 0.960001 54.1779 0.959998 48.0006C0.96 41.8232 2.17672 35.7063 4.5407 29.9991C6.90469 24.292 10.3696 19.1063 14.7377 14.7383L14.0589 14.0594Z",
    fill: "#11A0DA",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9411 14.0594C86.3983 18.5167 89.934 23.8081 92.3462 29.6318C94.7584 35.4554 96 41.6971 96 48.0006C96 54.304 94.7584 60.5457 92.3462 66.3694C89.934 72.193 86.3983 77.4845 81.9411 81.9417L81.2623 81.2629C85.6304 76.8948 89.0953 71.7091 91.4593 66.002C93.8233 60.2948 95.04 54.1779 95.04 48.0006C95.04 41.8232 93.8233 35.7063 91.4593 29.9991C89.0953 24.292 85.6304 19.1063 81.2623 14.7383L81.9411 14.0594Z",
    fill: "#11A0DA",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.64 27.3593C71.3505 30.0698 73.5006 33.2876 74.9675 36.829C76.4344 40.3704 77.1894 44.1661 77.1894 47.9993C77.1894 51.8325 76.4344 55.6282 74.9675 59.1696C73.5006 62.711 71.3505 65.9288 68.64 68.6393L68.2272 68.2265C70.8835 65.5702 72.9905 62.4168 74.4281 58.9462C75.8657 55.4756 76.6056 51.7558 76.6056 47.9993C76.6056 44.2428 75.8657 40.523 74.4281 37.0524C72.9905 33.5818 70.8835 30.4284 68.2272 27.7721L68.64 27.3593Z",
    fill: "#11A0DA",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.36 27.3593C24.6495 30.0698 22.4994 33.2876 21.0325 36.829C19.5656 40.3704 18.8106 44.1661 18.8106 47.9993C18.8106 51.8325 19.5656 55.6282 21.0325 59.1696C22.4994 62.711 24.6495 65.9288 27.36 68.6393L27.7728 68.2265C25.1165 65.5702 23.0095 62.4168 21.5719 58.9462C20.1343 55.4756 19.3944 51.7558 19.3944 47.9993C19.3944 44.2428 20.1343 40.523 21.5719 37.0524C23.0095 33.5818 25.1165 30.4284 27.7728 27.7721L27.36 27.3593Z",
    fill: "#11A0DA",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetodologyWeaksignalIcon);
export default __webpack_public_path__ + "static/media/metodology-weaksignal-icon.09c4c5c456b68cd8edfe959ed0a05158.svg";
export { ForwardRef as ReactComponent };